import { text_notes_auto_open } from 'config';
import applyHighlights from 'lib/applyHighlights.js';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('auth', ['currentUser', 'isAuthenticated']),
    autoopenEnabled() {
      const { cart, artwork, artist } = text_notes_auto_open;
      return cart || artwork || artist;
    },
  },
  methods: {
    canAutoOpenType(type) {
      return (
        ((type === 'cart' || type === 'header_cart') && text_notes_auto_open.cart) ||
        ((type === 'artwork' || type === 'header_artwork') && text_notes_auto_open.artwork) ||
        ((type === 'artist' || type === 'header_artist') && text_notes_auto_open.artist)
      );
    },
    getFirstHeaderTextNote(element) {
      if (element.text_notes) {
        let textNoteId;
        for (let key of Object.keys(element.text_notes)) {
          if (/header/.test(key)) {
            let firstTextNote = element.text_notes[key][0];
            if (typeof firstTextNote !== 'undefined' && this.canAutoOpenType(key)) {
              textNoteId = firstTextNote.id;
              break;
            }
          }
        }
        if (typeof textNoteId === 'undefined' && Object.keys(element.text_notes).length) {
          return this.getTextNoteId(element.text_notes);
        } else {
          return textNoteId;
        }
      }
    },
    getTextNoteId(artworkTextNotes) {
      if (artworkTextNotes) {
        for (let key of Object.keys(artworkTextNotes)) {
          let firstTextNote = artworkTextNotes[key][0];
          if (typeof firstTextNote !== 'undefined' && this.canAutoOpenType(key)) {
            return firstTextNote.id;
          }
        }
      }
    },
    getTextNoteById(textNotes, id) {
      for (let key of Object.keys(textNotes)) {
        for (let note of textNotes[key]) {
          if (note.id === id) {
            return note;
          }
        }
      }
    },
    getFirstNonHeaderTextNote(deepSearch) {
      if (deepSearch && this.elements) {
        for (let element of this.elements) {
          if (element.id === this.artwork.id && typeof element.text_notes !== 'undefined') {
            return this.getNonHeaderTextNoteId(element.text_notes);
          }
        }
      }
      return this.getNonHeaderTextNoteId(this.artwork.text_notes);
    },
    getNonHeaderTextNoteId(artworkTextNotes) {
      let textNoteId;
      if (artworkTextNotes) {
        for (let key of Object.keys(artworkTextNotes)) {
          if (/header/.test(key)) {
            continue;
          }
          let firstTextNote = artworkTextNotes[key][0];
          if (typeof firstTextNote !== 'undefined' && this.canAutoOpenType(key)) {
            textNoteId = firstTextNote.id;
            break;
          }
        }
      }
      return textNoteId;
    },
    getFirstHighlightTextNote() {
      let textNoteId;

      if (this.artwork && this.artwork.highlights) {
        const artwork = applyHighlights(this.artwork, this.artwork.highlights);
        if (artwork.text_notes) {
          for (let key of Object.keys(artwork.text_notes)) {
            let firstTextNote = artwork.text_notes[key][0];
            if (typeof firstTextNote !== 'undefined' && firstTextNote.extract.indexOf('yellow-highlight') !== -1) {
              textNoteId = firstTextNote.id;
              break;
            }
          }
        }
      }

      return textNoteId;
    },
    hasNote(noteId) {
      const { index } = this.$route.query;
      const parsedNoteId = noteId?.split('-').reverse()[0];
      let hasNote = false;
      let element;

      if (this.artwork.text_notes) {
        for (let key of Object.keys(this.artwork.text_notes)) {
          let valArr = this.artwork.text_notes[key];
          for (let el of valArr) {
            if (el.id === parsedNoteId) {
              hasNote = true;
            }
          }
        }
      }

      if (index && this.elements) {
        element = this.elements[index];
        if (element && element.text_notes) {
          for (let key of Object.keys(element.text_notes)) {
            let valArr = element.text_notes[key];
            for (let el of valArr) {
              if (el.id === parsedNoteId) {
                hasNote = true;
              }
            }
          }
        }
      }

      return hasNote;
    },
    autoOpenTextNote() {
      const { isHeader, index } = this.$route.query;
      let element;
      if (index && this.elements) {
        element = this.elements[index];
      }

      if (!this.autoopenEnabled) {
        return;
      }

      let textNoteId;
      if (this.isNonSeparable || this.isSeparable) {
        if (element) {
          textNoteId = this.getFirstHeaderTextNote(element);
        } else if (!isHeader) {
          if (this.isSeparable) {
            textNoteId = this.getFirstNonHeaderTextNote(true);
          } else {
            textNoteId = this.getFirstHeaderTextNote(this.artwork);
          }
        }
      } else {
        textNoteId = this.getTextNoteId(this.artwork.text_notes);
      }

      if (
        !isNaN(textNoteId) &&
        !(
          this.isAuthenticated &&
          (this.currentUser.abilities.text_note.read_unpublished || this.currentUser.abilities.text_note.edit_own)
        )
      ) {
        this.preventAutoTextNote = true;
      }

      if (!this.preventAutoTextNote && textNoteId && this.hasNote(textNoteId)) {
        const query = Object.assign({}, this.$route.query);
        this.$router.replace({ name: 'ArtworkNote', query, params: { note: textNoteId } }).catch((err) => {});
      } else {
        textNoteId = this.getFirstHighlightTextNote();
        const updateValue = this.preventAutoTextNote ? null : textNoteId;
        const query = Object.assign({}, this.$route.query);
        const params = Object.assign({ note: updateValue }, this.$route.params);
        const name = params.note ? 'ArtworkNote' : 'artwork';
        this.$router.replace({ name, query, params }).catch((err) => {});
      }
    },
  },
};
